<div class="page-container">
  <app-toolbar [title]="'COMMON.MEETINGS' | translate"></app-toolbar>
  <div class="page">
    <div class="wrapper">
      <div class="left">
        <div class="past">
          @if (pastMeetings$ | async; as query) {
            @if (query.result$ | async; as result) {
              @if (result.isLoading) {
                <app-spinner></app-spinner>
              } @else if (result.isSuccess) {
                <app-meeting-list
                  #pastMeetingList
                  [meetings]="getAllMeetings(result.data!)"
                  [hasMore]="result.data!.pages.at(-1)?.hasMore ?? false"
                  [isFetchingNextPage]="result.isLoading || result.isFetchingNextPage"
                  [meetingListType]="'past'"
                  [useGroupingByDate]="true"
                  (fetchNextPage)="result.fetchNextPage()"
                  (hoverMeeting)="prefetchMeeting($event)"
                  (meetingGotIntoView)="setPastMeetingQueryParameter($event)"
                ></app-meeting-list>
              }
            }
          }
        </div>
      </div>
      <div class="right">
        <div class="upcoming">
          @if (upcomingMeetingsQuery.result$ | async; as result) {
            @let calendarSyncState = calendarSyncState$ | async;
            @if (result.isLoading) {
              <app-spinner></app-spinner>
            } @else if (result.isSuccess) {
              @if (calendarSyncState && calendarSyncState !== 'IDLE' && getAllMeetings(result.data!).length === 0) {
                <app-calendar-sync-state [state]="calendarSyncState"></app-calendar-sync-state>
              } @else {
                <app-meeting-list
                  #upcomingMeetingList
                  [meetings]="getAllMeetings(result.data!)"
                  [hasMore]="result.data!.pages.at(-1)?.hasMore ?? false"
                  [isFetchingNextPage]="result.isFetchingNextPage"
                  [meetingListType]="'upcoming'"
                  [useGroupingByDate]="true"
                  (fetchNextPage)="result.fetchNextPage()"
                  (hoverMeeting)="prefetchMeeting($event)"
                  (meetingGotIntoView)="setUpcomingMeetingQueryParameter($event)"
                ></app-meeting-list>
              }
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>
